<section class="say-hello">
	<section class="gennius--intro" id="home" >
		<div class="content">
			<h1><span>Building<br>Human-to-Human</span>technologies</h1>
			<h4 class="text-gradient">Empowering rewards </h4>
			<span>and <strong>Web3 platforms</strong> to create superior user experiences and bring digital engagement and loyalty to new levels.
			</span>
			<!-- <button class="btn-gennius" (click)="openVideo('1')">Watch video</button> -->
		</div>
		<app-connect></app-connect>
		<div class="filter"></div>
		<video *ngIf="!itsMobile" autoplay="" loop="loop" playsinline="" oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="./assets/img/cryptmi/bg-poster.png">
			<source
				src="https://player.vimeo.com/progressive_redirect/playback/597805071/rendition/720p/file.mp4?loc=external&signature=5cc558a0fe9006e030607885967785150dd17aca1fffa7863549016b283bdbc7"
				type="video/mp4">
		</video>
		
		
	</section>
<!-- <app-say-hello (messageEvent)="receiveMessage($event)" (xEvent)="getMessage($event)"></app-say-hello> -->
	<section class="section parallax1">
		<div class="bg-wrap">
			<div class="bg"></div>
		</div>
		<div class="container">
            <div class="alinear-izquierda">
                <h2>
                    Say hello <br> to the <br>
                    <img src-tmp="./assets/img/cryptmi/miles-logo.svg" alt="">
                    platform
                </h2>
                <h3 class="text-gradient">A Super App <br> as a Service</h3>
                <p>with built-in rewards and <br> embedded finance for a <br> <strong>connected world.</strong></p>
            </div>
            <div class="alinear-derecha">
                <div class="phone">
                    <div class="content">
						<video class="video-vimeo registration" autoplay="" loop="loop" playsinline="" oncanplay="this.play()" onloadedmetadata="this.muted = true">
							<source
							src="https://player.vimeo.com/progressive_redirect/playback/708795944/rendition/720p/file.mp4?loc=external&signature=29ed01b729eab5c2643374fa6b127b896697fa788a7e94d42353bee3a6fdfbb8"
							type="video/mp4">
						</video>
                  
                    </div>
                </div>
            </div>
        </div>
	</section>
    <section class="section parallax2">
        <div class="bg-wrap">
			<div class="bg"></div>
		</div>
        <div class="container">
            <div class="alinear-izquierda">
                <h2>Marketplace</h2>
                <h3 class="text-gradient">Voyage <br> Connected <br> World.</h3>
                <p>Choose from over <strong>28 million travel <br>deals</strong> with member preferred rates, <br>stellar benefits and travel protection.</p>
            </div>
            <div class="alinear-derecha">
                <img class="image" src-tmp="./assets/img/cryptmi/say-hello2.png" alt="">
                <img class="element" src-tmp="./assets/img/cryptmi/element-trama2.png" alt="">
            </div>
        </div>
    </section>
    <section class="section parallax3">
		<div class="bg-wrap">
			<div class="bg"></div>
		</div>
        <div class="container">
            <div class="alinear-izquierda">
                <img class="image" src-tmp="./assets/img/cryptmi/say-hello3.png" alt="">
            </div>
            <div class="alinear-derecha">
                <h2>100+ million merchants</h2>
                <h3 class="text-gradient">Shop and <br> redeem in app <br> and in store <br> worldwide.</h3>
                <p><strong>Split your payment to combine</strong> <br>rewards, debit/credit cards, crypto, <br> and pay in installments.</p>
            </div>
        </div>
    </section>
    <section class="section parallax4 ">
        <div class="bg-wrap">
			<div class="bg"></div>
		</div>
        <div class="container">
            <div class="alinear-izquierda">
                <h2>Web3</h2>
                <h3 class="text-gradient">Empower <br> life with <br> simplicity.</h3>
                <p><strong>Blend all your digital assets</strong> to pay <br> for everyday essentials, NFTs and <br> purchases in the metaverse, by <br> making dynamic and instant swaps <br> between bank rewards, crypto and <br> local currencies.</p>
            </div>
            <div class="alinear-derecha">
                <img class="image" src-tmp="./assets/img/cryptmi/say-hello4.png" alt="">
            </div>
        </div>
        <div class="slide-cripto">
            <div class="animate">
                <img src-tmp="./assets/img/cryptmi/scroll-ecommerce.svg" alt="">
            </div>
            <div class="animate2">
                <img src-tmp="./assets/img/cryptmi/scroll-ecommerce2.svg" alt="">
            </div>
        </div>
    </section>
	<section class="section parallax5">
		<section class="gennius--genetic">
			<div class="container gennius">
				<div class="gennius__bloque">
					<div class="gennius__left">
						<h3>Gennius is embedded in<br> our genetic code</h3>
					</div>
					<div class="gennius__right">
						<span>It lives and breathes through the things we do and thrives and grows in the generations we make things for. </span>
					</div>
				</div>
			</div>
		</section>
		<section class="gennius-padding gennius-genetic--section gennius--container">
			<div class="container gennius">
				<div class="gennius__bloque gennius__bloque--top">
					<div class="gennius__column">
						<img class="gennius__img" src="./assets/img/gennius/column-genetic-1.png" alt="gennius">
						<div class="gennius__content">
							<h4 class="text-gradient">X stands for what we do:</h4>
							<p>the products and services your business provides to your customers.</p>
						</div>
					</div>
					<div class="gennius__column">
						<img class="gennius__img" src="./assets/img/gennius/column-genetic-2.png" alt="gennius">
						<div class="gennius__content">
							<h4 class="text-gradient">Y is the target audience</h4>
							<p>or customers of your business, mostly GenXers, GenYers or Millennials, and GenZers.</p>
						</div>
					</div>
					<div class="gennius__column">
						<img class="gennius__img" src="./assets/img/gennius/column-genetic-3.png" alt="gennius">
						<div class="gennius__content">
							<h4 class="text-gradient">Z is the <br>benefit</h4>
							<p>of doing business with our partners.</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="gennius--meet">
			<div class="container gennius">
				<div class="gennius__bloque">
					<div class="gennius__left gennius__left--meet">
						<h3>Turnkey solution<br> under one<br> umbrella</h3>
						<p>Our turnkey, white-label solutions are designed to achieve unparalleled loyalty effect, combining all rewards payments and Web3 features into one holistic platform <strong>for issuers to increase revenue and users to enjoy unrivaled benefits.</strong></p>
					</div>
				</div>
				<div class="gennius__bloque gennius__bloque--hyper">
					<div class="gennius__left gennius__left--meet gennius__left--hyper">
						<h3>Meet our hyper-<br>connected solutions</h3>
						<p><strong>We have explored new engagement dimensions</strong> by experimenting with different prospects, with new concepts that function dynamically and across markets through new technology and evolving capabilities to deliver best outcomes.</p>
					</div>
				</div>
				<div class="gennius__bloque gennius__bloque--item" #counter>
					<div class="gennius__item">
						<span class="text-gradient counter counter-1">7.5 million</span>
						<p>Card holders & crypto holders accessing in 129 countries</p>
					</div>
					<div class="gennius__item">
						<span class="text-gradient counter counter-2">24+ billion</span>
						<p>rewards balance</p>
					</div>
					<div class="gennius__item">
						<span class="text-gradient counter counter-3">300+</span>
						<p>rewards programs</p>
					</div>
					<div class="gennius__item">
						<span class="text-gradient counter counter-4">64</span>
						<p>connected Banks</p>
					</div>
					<div class="gennius__item">
						<span class="text-gradient counter counter-5">250+</span>
						<p>cryptocurrencies available to swap for CYMI</p>
					</div>
					<div class="gennius__item">
						<span class="text-gradient counter counter-6">10</span>
						<p>years digital processing</p>
					</div>
				</div>
				<button class="btn-gennius" pageScroll href="#solutions" [routerLink]="['/solutions']">Enter our solution</button>
			</div>
		</section>
		<section class="gennius--proud">
			<div class="container gennius">
				<h3>Proud members of Visa Fintech Partner Connect</h3>
				<div class="gennius__bloque">
					<div class="gennius__left gennius__left--proud">
						<!-- <img class="gennius__img--proud" src="./assets/img/gennius/logo-visa-partner.png" alt="gennius"> -->
						<p>Connecting Visa’s clients with <strong>Visa Fintech Partner Connect</strong> partners: Visa believes in the power of technology and innovation to improve cardholder digital experiences and open up new value for Visa cardholders and clients around the globe.</p>
						<div class="buttons">
							<a class="btn-gennius" href="https://partner.visa.com/site/partner-directory/novae.html" target="_blank">Learn more</a>
							<a class="btn-gennius btn-gennius--black" href="./assets/docs/VCA-Novae-Product-Launch-Research-Full-Report-04192022.pdf" target="_blank">Download Visa VCA Report</a>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="gennius--experiences">
			<div class="container gennius">
				<div class="gennius__bloque">
					<div class="gennius__left gennius__left--experiences">
						<div class="gennius__text">
							<span>Our brands</span>
							<div class="bl-brands">
								<div class="item">
									<img src="./assets/img/gennius/logo-novae.png" alt="gennius">
									<p>B2B smart payments infrastructure</p>
								</div>
								<div class="item">
									<img src="./assets/img/gennius/logo-miles.png" alt="gennius">
									<p>End-to-end-loyalty solutions</p>
								</div>
								<div class="item">
									<img src="./assets/img/gennius/logo-cryptmi.png" alt="gennius">
									<p>Web3 and crypto<br> market</p>
								</div>
							</div>

						</div>
						<h3>Experiences & partnerships</h3>
						<p>Strategic partnerships between companies have the potential to propel remarkably effective business ventures. <strong>Gennius’</strong> companies have a powerful consortium, extensive strategic alliances and banks connected across industries.</p>
					</div>
				</div>
			</div>
			<div class="slide-cripto">
				<div class="animate">
					<img src-tmp="./assets/img/cryptmi/scroll-partners2.svg" alt="">
				</div>
				<div class="animate2">
					<img src-tmp="./assets/img/cryptmi/scroll-hotels.svg" alt="">
				</div>
			</div>
		</section>
		<!-- <div class="bg-video content" [ngClass]="{'open': video1}" [style.display]="!hidden? 'none': 'block'">
			<div class="full-video content-video">
				<video class="main-video">
					<source
						src-tmp="https://player.vimeo.com/progressive_redirect/playback/708795449/rendition/540p/file.mp4?loc=external&signature=fab1103da4cad90cd99a4982fb3ecfbbf21b30b122db0e388f3c317f01e9fd88"
						type="video/mp4">
				</video>
			</div>
			<span class="icon-close" (click)="closeVideo('1')"></span>
		</div> -->
		<app-footer></app-footer>
		<section class="section clearBoth"></section>
	</section>
</section>
